import React, { useState, useEffect, useRef, forwardRef , Fragment} from "react";
import {TextField,
        Grid,
        InputAdornment,
        Box,
        Button,
        CircularProgress,
        Switch,
        Typography,
        NativeSelect,
        InputLabel,
        FormControl,
        MenuItem,
        FormHelperText,
        Link
} from "@material-ui/core";
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import CommentIcon from '@material-ui/icons/Comment';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import HistoryIcon from '@material-ui/icons/History';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import MapIcon from '@material-ui/icons/Map';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import useStyles from './styles';
import classnames from "classnames";
import ttAPI from '../../api/ttAPI';
import config from '../../config';
import Widget from '../../components/Widget';
import AddressAutoComplete from '../../components/AddressAutoComplete/AddressAutoComplete';
import SelectSiteTestingScopes from './SelectSiteTestingScopes';

import { sendNotification, useUserState } from "../../context/UserContext";
import './Pricing.css'
import './SelectSiteTestingScopes.css'
import './UpdateSite.css'

const UpdateSite = forwardRef((props, ref) => {
    // global
    const { onUpdateSuccess } = props
    const classes = useStyles();
    var { regions, geo_regions } = useUserState();
    const [newSite, setNewSite] = useState({...props.createdSite});
    const [isSaving, setIsSaving] = useState(false);
    const [selectedChargeBy, setSelectedChargeBy] = useState('Tag');
    const siteWidgetRef = useRef(null);
    const sitePricingWidgetRef = useRef(null);
    const [selectedRegionId, setSelectedRegionId] = useState(-1);
    const [regionOptions, setRegionOptions] = useState([]);
    const [selectedGeoRegionId, setSelectedGeoRegionId] = useState(-1);
    const [geoRegionOptions, setGeoRegionOptions] = useState([]);
    const [noRegionSelectedError, setNoRegionSelectedError] = React.useState(false);


    useEffect(() => {
        if (newSite.hourly_charge !== null && newSite.hourly_charge !== undefined && newSite.hourly_charge > 0) {
            setSelectedChargeBy('Hour');
        }
        else {
            setSelectedChargeBy('Tag');
        }

        if (newSite.franchise_id !== undefined && newSite.franchise_id > 0) {
            setSelectedRegionId(newSite.franchise_id);
        }

        if (newSite.geo_region_id !== undefined && newSite.geo_region_id > 0) {
            setSelectedGeoRegionId(newSite.geo_region_id);
        }
    },[newSite]);

    useEffect(() => {
      var tempRegions = [];
      tempRegions.push(<option key="0" aria-label="None" value="" />);
      if (regions !== undefined) {
          regions.map(region => {
            if (region.id) {
              tempRegions.push(<Fragment key={region.id}><option value={region.id}>{region.name}</option></Fragment>)
            }
            return tempRegions;
          });
      }
      setRegionOptions(tempRegions);
    }, [regions]);

    useEffect(() => {
      var tempGeoRegions = [];
      tempGeoRegions.push(<option key="0" aria-label="None" value="" />);
      if (geo_regions !== undefined) {
          geo_regions.map(geo_region => {
            if (geo_region.id) {
              tempGeoRegions.push(<Fragment key={geo_region.id}><option value={geo_region.id}>{geo_region.name}</option></Fragment>)
            }
            return tempGeoRegions;
          });
      }
      setGeoRegionOptions(tempGeoRegions);
    }, [geo_regions]);

     function handleChange(e) {
       setNewSite({
         ...newSite,
         [e.target.name]: e.target.value,
       });
     }

       function onSelectSiteAddress(address) {
         setNewSite({
           ...newSite,
           address: address
         });
       }

       function onGeoLocationFetched(geolocation) {
         var geoRegion = geo_regions.find(geo_region => geolocation.region.toUpperCase() === 'Manawatu-Wanganui' ? 'Manawatū-Whanganui' === geo_region : geolocation.region.toUpperCase() === geo_region.name.toUpperCase());
         var geoRegionId = geoRegion !== undefined && geoRegion !== null ? geoRegion.id : -1;
         setSelectedGeoRegionId(geoRegionId);
         setNewSite({
           ...newSite,
           geo_region_id: geoRegionId,
           geo_locality: geolocation.locality,
           mapurl: `https://maps.google.co.nz/maps?q=${geolocation.lat},${geolocation.lng}`
         });
       }

       const disableSaveButton = () => {
         if (!isSaving && props.isNotesOnly) {
           return false;
         }
         return isSaving || (newSite.name === undefined || newSite.name === null || newSite.name === '' ||
                newSite.address === undefined || newSite.address == null || newSite.address === '' ||
                newSite.franchise_id === undefined || newSite.franchise_id === null || newSite.franchise_id <= 0) ||
                (newSite.testing_scopes === undefined || newSite.testing_scopes === null || newSite.testing_scopes.length <= 0) ||
                (newSite.testing_scopes !== undefined && newSite.testing_scopes !== null && newSite.testing_scopes.length > 0 &&
                  ((newSite.testing_scopes.find(item => item !== undefined && item !== null && (item.name !== undefined && item.name !== null && item.name.toLowerCase().includes('please make a note'))) !== undefined) &&
                    (newSite.testing_scope_other_notes== undefined || newSite.testing_scope_other_notes === null || newSite.testing_scope_other_notes === '')));
       }

       const updateSite = async () => {
           setIsSaving(true);
           var siteToSave = newSite;
           if (siteToSave.testing_scopes !== undefined && siteToSave.testing_scopes !== null) {
             siteToSave.testing_scopes.map(testing_scope => {console.log(testing_scope, isNaN(testing_scope));return testing_scope.id === undefined ? testing_scope : testing_scope.id});
               siteToSave.testing_scopes = siteToSave.testing_scopes.map(testing_scope => testing_scope.id === undefined ? testing_scope : testing_scope.id);
           }
           if (selectedChargeBy === 'Tag') {
               siteToSave.hourly_charge = 0;
           }
           else {
               if (siteToSave.hourly_charge === null || siteToSave.hourly_charge === undefined || siteToSave.hourly_charge <= 0) {
                   siteToSave.hourly_charge = siteToSave.default_hourly_charge;
               }
           }
           if (props.isNotesOnly) {
             const response = await ttAPI.saveSiteNotes(siteToSave);
             if (response.data !== undefined && response.data !== null && response.data.length > 0 && response.data[0].ok === 'true') {
               onUpdateSuccess();
               sendNotification('success', 'Success - Site Notes Updated.', classes)
             }
             else {
               sendNotification('error', 'Error update site notes.', classes)
             }
           }
           else {
             const response = await ttAPI.saveSite(siteToSave);
             if (response !== undefined && response !== null && response.data !== undefined && response.data !== null && response.data.length > 0 && response.data[0].ok === 'true') {
               onUpdateSuccess();
               sendNotification('success', 'Success - Site Updated.', classes)
             }
             else {
               sendNotification('error', 'Error update site.', classes)
             }
           }
           setIsSaving(false);
       }

       function onClickArchiveSwitch() {
           setNewSite({
             ...newSite,
             active: newSite.active === undefined || newSite.active === null ? false : !newSite.active
           });
       }

       function handleChangeSelectChargeBy(e) {
           setSelectedChargeBy(e.target.value);
           if (e.target.value === 'Tag') {
               setNewSite({
                 ...newSite,
                 hourly_charge: 0,
               });
           }
       }

       function onTestingScopesSelected(testingScopes) {
           setNewSite({
             ...newSite,
             testing_scopes: testingScopes,
           });
       }

       function onOtherTestingScopesSpecified(otherTestingScopeNotes) {
         setNewSite({
           ...newSite,
           testing_scope_other_notes: otherTestingScopeNotes,
         });
       }

       const downloadHistory = () => {
         if (newSite.id === undefined) {
             sendNotification('error','Cannot download history, invalid site id');
         }
         else {
             window.open(`${config.clientApi}/reports/audit/site?id=${newSite.id}`,'_blank');
         }


         siteWidgetRef.current.closeWidgetMoreMenu();
       }

       const downloadPricingHistory = () => {
         if (newSite.id === undefined) {
             sendNotification('error','Cannot download pricing history, invalid site id');
         }
         else {
             window.open(`${config.clientApi}/reports/audit/pricing/site?id=${newSite.id}`,'_blank');
         }


         sitePricingWidgetRef.current.closeWidgetMoreMenu();
       }

       function viewSiteForecast() {
         window.open(
         `${config.clientApi}/reports/site/forecast?site_id=${newSite.id}`,
         '_blank'
         );
         siteWidgetRef.current.closeWidgetMoreMenu();
       }

       function handleChangeRegion(e) {
         setNewSite({
           ...newSite,
           franchise_id: e.target.value === '' ? -1 : e.target.value,
         });
         setSelectedRegionId(e.target.value);
       }

       function handleChangeGeoRegion(e) {
         setNewSite({
           ...newSite,
           geo_region_id: e.target.value === '' ? -1 : e.target.value,
         });
         setSelectedGeoRegionId(e.target.value);
       }

       function onBlurRegionSelection() {
         validateRegion();
       }

       function validateRegion() {
         setNoRegionSelectedError(selectedRegionId === undefined || selectedRegionId === null || selectedRegionId <= 0);
       }

  return (<div className={classes.contentDiv}>
    {/*}<div>{`props.createdSite is ${props.createdSite}`}</div>
    <div>{`props.createdSite.name is ${props.createdSite.name}`}</div>
    <div>{`props.createdSite.id is ${props.createdSite.id}`}</div>
    <div>{`props.createdSite.customerId is ${props.createdSite.customerId}`}</div>
    <div>{`newSite is ${newSite}`}</div>
    <div>{`newSite.name is ${newSite.name}`}</div>
    <div>{`newSite.id is ${newSite.id}`}</div>
    <div>{`newSite.customerId is ${newSite.customerId}`}</div>*/}

    <form>

        <Grid container spacing={4}>
           {props.isNotesOnly === undefined && <Grid item xs={12} md={6} sm={6}>

              <Widget
                title="Site Details"
                upperTitle
                noMinHeight
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                ref={siteWidgetRef}
                menuItems={<div>
                            <MenuItem onClick={downloadHistory}>
                               <HistoryIcon/><Typography>Download History</Typography>
                            </MenuItem>
                            <MenuItem onClick={viewSiteForecast}>
                               <CardMembershipIcon/>&nbsp;<Typography>View Forecast</Typography>
                            </MenuItem>
                           </div>
                         }>
                <div className={classes.formDisplay}>
              <TextField
                  id="name"
                  label="Name"
                  autoComplete='off'
                  onChange={handleChange}
                  name="name"
                  value={newSite.name || ''}
                  variant="outlined"
                  required
                  error={newSite.name === ''}
                  helperText={newSite.name === '' ? 'Please enter the name of the site.' : ' '}
                  size="small"
                />
                 <TextField
                    id="code"
                    label="Code"
                    autoComplete='off'
                    onChange={handleChange}
                    name="code"
                    value={newSite.code || ''}
                    variant="outlined"
                    style={{ marginBottom: 20 }}
                    size="small"
                  />
                </div>
                <Box display={"flex"} alignItems={"center"}>
                    <Typography weight={"medium"}>
                        Archived
                    </Typography>
                    <Switch color={"primary"} checked={!newSite.active}
                            onClick={onClickArchiveSwitch} />
                </Box>
            </Widget>

            <Widget
              title="Location"
              upperTitle
              className={classes.card}
              style={{ marginTop: 20 }}
              disableWidgetMenu
              noMinHeight
            >
              <div className={classes.formDisplay}>
                  <AddressAutoComplete presetValue={newSite.address} onSelect={onSelectSiteAddress} onLocationUpdate={onGeoLocationFetched} required/>
                  <FormControl variant="outlined" style={{ marginBottom: 20}}
                                className={classnames({
                                  [classes.error]: noRegionSelectedError,
                                  'select-control': true
                                })}>
                    <InputLabel id="region">Scheduling Zone / Region<sup>*</sup></InputLabel>
                    <div className={classnames({
                                  [classes.error]: noRegionSelectedError,
                                  'select-control-input': true
                                })}>
                      <InputAdornment position="start">
                        <HomeWorkIcon />
                      </InputAdornment>
                      <NativeSelect
                        value={selectedRegionId}
                        onChange={handleChangeRegion}
                        onBlur={onBlurRegionSelection}
                      >
                         {regionOptions}
                      </NativeSelect>
                    </div>
                    {noRegionSelectedError && <FormHelperText className={classes.error}>You must select a scheduling zone / region for the site!</FormHelperText>}
                  </FormControl>

                  <FormControl variant="outlined" style={{ marginBottom: 20}}
                                className={classnames({
                                  'select-control': true
                                })}>
                    <InputLabel id="geo_region">Geographic Region</InputLabel>
                    <div className={classnames({
                                  'select-control-input': true
                                })}>
                      <InputAdornment position="start">
                        <MapIcon />
                      </InputAdornment>
                      <NativeSelect
                        value={selectedGeoRegionId}
                        onChange={handleChangeGeoRegion}
                      >
                         {geoRegionOptions}
                      </NativeSelect>
                      {/*<FormHelperText>Result returned from GeoAPI: {newSite.geo_region_name}</FormHelperText>*/}
                    </div>
                  </FormControl>

                  <TextField
                      id="geo_locality"
                      label="Geographic Locality"
                      autoComplete='off'
                      onChange={handleChange}
                      name="geo_locality"
                      value={newSite.geo_locality || ''}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LocationCityIcon />
                          </InputAdornment>
                        ),
                      }}
                    />

                    {newSite.mapurl !== null && newSite.mapurl !== undefined && newSite.mapurl !== '' &&
                    <Link href={newSite.mapurl} target="_blank"
                          style={{marginLeft: '10px', fontSize: '16px', textDecoration: 'underline', marginTop: '10px'}}>
                            View Map
                    </Link>}
              </div>
            </Widget>

          </Grid>}

          {props.isNotesOnly === undefined && <Grid item xs={12} md={6} sm={6}>
            <Widget
              title="Contact"
              upperTitle
              className={classes.card}
              disableWidgetMenu
              noMinHeight
            >
              <div className={classes.formDisplay}>
                <TextField
                  id="contact"
                  label="Contact"
                  autoComplete='off'
                  onChange={handleChange}
                  name="contact"
                  value={newSite.contact || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AssignmentIndIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  id="phone"
                  label="Phone"
                  autoComplete='off'
                  onChange={handleChange}
                  name="phone"
                  value={newSite.phone || ''}
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PhoneIcon />
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  id="email"
                  label="Email"
                  autoComplete='off'
                  onChange={handleChange}
                  value={newSite.email || ''}
                  name="email"
                  variant="outlined"
                  style={{ marginBottom: 20 }}
                  type={'email'}
                  size="small"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </Widget>

            <Widget
              title="Others"
              upperTitle
              className={classes.card}
              style={{ marginTop: 20 }}
              disableWidgetMenu
              noMinHeight
            >
              <div className={classes.formDisplay}>
                  {props.inTab === undefined && <TextField
                   id="notes"
                   name="notes"
                   label="Notes"
                   autoComplete='off'
                   value={newSite.notes || ''}
                   multiline
                   rows="5"
                   variant="outlined"
                   onChange={handleChange}
                   style={{ marginBottom: 20 }}
                   size="small"
                   InputProps={{
                     className: classes.textarea,
                     startAdornment: (
                       <InputAdornment position="start">
                         <CommentIcon />
                       </InputAdornment>
                     ),
                   }}
                 />}

                 <div className={classes.testingScopes}>
                   <SelectSiteTestingScopes
                                    isAddSite={false}
                                    site={newSite}
                                    onTestingScopesSelected={onTestingScopesSelected}
                                    onOtherTestingScopesSpecified={onOtherTestingScopesSpecified}/>
                 </div>

              </div>
            </Widget>
          </Grid>}

          {props.isNotesOnly === undefined && <Grid item xs={12} md={12} sm={12}>
              <Widget
                title="Site Pricing"
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                ref={sitePricingWidgetRef}
                menuItems={<div>
                           <MenuItem onClick={downloadPricingHistory}>
                               <HistoryIcon/><Typography>Download Pricing History</Typography>
                           </MenuItem>

                           </div>
                         }>
                <div className={classes.pricingDisplay}>
                    <FormControl variant="outlined" className={classnames({
                          'chargeBySelect':  true,
                          'chargeby-select-control': true
                        })}>
                      <InputLabel>Charge By</InputLabel>
                      <div className={classnames({
                                    'chargeby-select-control-input': true
                                  })}>
                        <NativeSelect
                          value={selectedChargeBy}
                          onChange={handleChangeSelectChargeBy}
                        >
                           <option value="Tag">Tag</option>
                           <option value="Hour">Hour</option>
                        </NativeSelect>
                      </div>
                    </FormControl>
                    {selectedChargeBy === 'Hour' && <TextField
                      id="hourlyCharge"
                      label="Hourly Charge"
                      onChange={handleChange}
                      value={newSite.hourly_charge === undefined || newSite.hourly_charge === null || newSite.hourly_charge <= 0 ? newSite.default_hourly_charge : newSite.hourly_charge}
                      name="hourly_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />}

                    <TextField
                      id="minCharge"
                      label="Min Charge"
                      onChange={handleChange}
                      value={newSite.min_charge}
                      name="min_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="minCashCharge"
                      label="Min Cash Charge"
                      onChange={handleChange}
                      value={newSite.min_cash_charge}
                      name="min_cash_charge"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="localTravel"
                      label="Local Travel"
                      onChange={handleChange}
                      value={newSite.local_travel}
                      name="local_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="seventyHundredTravel"
                      label="Travel 60 - 100km"
                      onChange={handleChange}
                      value={newSite.seventy_hundred_travel}
                      name="seventy_hundred_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="over100Travel"
                      label="Region Travel > 100km"
                      onChange={handleChange}
                      value={newSite.over_100_travel}
                      name="over_100_travel"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    {selectedChargeBy === 'Tag' && <><TextField
                      id="singlePhasePrice"
                      label="Single Phase Price"
                      onChange={handleChange}
                      value={newSite.single_phase_price}
                      name="single_phase_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    <TextField
                      id="threePhasePrice"
                      label="Three Phase Price"
                      onChange={handleChange}
                      value={newSite.three_phase_price}
                      name="three_phase_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />
                    <TextField
                      id="rcdPrice"
                      label="RCD Price"
                      onChange={handleChange}
                      value={newSite.rcd_m_price}
                      name="rcd_m_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="firePrice"
                      label="Fire Price"
                      onChange={handleChange}
                      value={newSite.fire_price}
                      name="fire_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="fistAidPrice"
                      label="First Aid Price"
                      onChange={handleChange}
                      value={newSite.first_aid_price}
                      name="first_aid_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="medicalPrice"
                      label="Medical Price"
                      onChange={handleChange}
                      value={newSite.medical_price}
                      name="medical_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="rcdPbPrice"
                      label="RCD PB Price"
                      onChange={handleChange}
                      value={newSite.rcd_pb_price}
                      name="rcd_pb_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="lgPbPrice"
                      label="LG PB Price"
                      onChange={handleChange}
                      value={newSite.lg_pb_price}
                      name="lg_pb_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="lgMPrice"
                      label="LG6 Measured Price"
                      onChange={handleChange}
                      value={newSite.lg_m_price}
                      name="lg_m_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="threePhaseRcdPrice"
                      label="3 Phase RCD Price"
                      onChange={handleChange}
                      value={newSite.three_phase_rcd_price}
                      name="three_phase_rcd_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="microwavePrice"
                      label="Microwave Price"
                      onChange={handleChange}
                      value={newSite.microwave_price}
                      name="microwave_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="nonElectricalPrice"
                      label="Non Electrical Price"
                      onChange={handleChange}
                      value={newSite.non_electrical_price}
                      name="non_electrical_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="ladderPrice"
                      label="Ladder Price"
                      onChange={handleChange}
                      value={newSite.ladder_price}
                      name="ladder_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="aedPrice"
                      label="AED Price"
                      onChange={handleChange}
                      value={newSite.aed_price}
                      name="aed_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    />

                    <TextField
                      id="evsePrice"
                      label="EVSE Price"
                      onChange={handleChange}
                      value={newSite.evse_price}
                      name="evse_price"
                      variant="outlined"
                      style={{ marginBottom: 20 }}
                      type={'number'}
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AttachMoneyIcon />
                          </InputAdornment>
                        ),
                      }}
                      required
                    /></>}
                </div>
              </Widget>
              </Grid>}

          { props.isNotesOnly &&
            <TextField
              id="site_notes_only"
              name="notes"
              label={`${newSite.name || ''} Notes`}
              autoComplete='off'
              value={newSite.notes || ''}
              multiline
              rows="5"
              variant="outlined"
              onChange={handleChange}
              style={{ marginBottom: 20, width: '100%', marginTop: 20}}
              size="small"
              InputProps={{
                className: classes.textarea,
                startAdornment: (
                  <InputAdornment position="start">
                    <CommentIcon />
                  </InputAdornment>
                ),
              }}
            />
          }


          <div className={classes.bottomMenu}>
              <div>
              <Box
                  display={'flex'}
                  justifyContent={'flex-end'}
              >
                  <Button className={classes.updateSiteButton}
                      color="primary"
                      disabled={disableSaveButton()}
                      onClick={updateSite}
                  >
                  {isSaving && <span><CircularProgress size={25}/> Saving...</span>}
                  {!isSaving && props.isNotesOnly === undefined && <span>Save Site</span>}
                  {!isSaving && props.isNotesOnly && <span>Save Site Notes</span>}
                  </Button>
              </Box>
              </div>
          </div>
        </Grid>

      </form>
    </div>
  );
//}
});
export default UpdateSite;
